module.exports = __webpack_public_path__ + "media/images/web_suite/resources_thumbs/featured-learn-site-thumbnail_fr-6877596fab5e58bcaba941258a6e67ad.png";